import React, { useCallback, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import ReactModal from "react-modal";
import { useHistory } from "react-router-dom";
import { message, Spin } from "antd";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import {
  get_special_pricing_list_api,
  get_pymtplan_dropdown_api,
  add_special_pricing_api,
  edit_special_pricing_api,
} from "../services/AdminProgramApi";

const theme = localStorage.getItem("brandColor") || "#ff8c24";

const StyledDiv = styled.div`
  justify-content: center;
  margin: 0 auto;
`;

const StyledTable = styled.table`
  width: 100%;
  height: 3%;
`;

const ScrollTableHeader = styled.tr`
  background: ${theme};
  font-weight: bold;
  color: #ffffff;
  font-family: Nunito;
  font-style: normal;
  position: sticky;
  top: 0;
`;

const StyledTableHeaderData = styled.th`
  font-weight: bold;
  padding: 5px;
  font-family: Nunito;
  font-style: normal;
  text-align: center;
`;

const StyledTableRow = styled.tr`
  border-bottom: 1px solid #9d9d9d;
`;

const StyledButton1 = styled.button`
  background: ${theme};
  width: 100%;
  border-radius: 30px;
  height: 45px;
  text-align: center;
  color: white;
  font-size: 16px !important;
  font-weight: 500;
  border: none;
  margin-top: 25px;
  padding: 5px 10px;
`;

const useFormTextFieldStyles = makeStyles(() => ({
  textField: {
    width: "100%",
    alignItems: "center",
    border: "1px solid black",
  },
}));

const StyledButton = styled.button`
  background: ${theme};
  width: auto;
  min-width: 200px;
  border-radius: 30px;
  height: 55px;
  text-align: center;
  color: white;
  font-size: 18px !important;
  font-weight: 500;
  border: none;
  margin: 8px;
  padding: 5px 20px;
`;

const StyledButtonSmall = styled.button`
  background: ${theme};
  width: auto;
  border-radius: 20px;
  height: 32px;
  text-align: center;
  color: white;
  font-size: 14px !important;
  font-weight: 500;
  border: none;
  margin: 4px;
  padding: 0 16px;
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
`;

const FormDivStyle = {
  position: "relative",
  display: "inline",
  width: "100%",
  textAlign: "left",
};

const StyledFormInputDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 8px;
  width: 100%;
  gap: 4px;
  @media (max-width: 576px) {
    flex-direction: column;
  }
`;

const StyledLabel = styled.label`
  flex: 0 0 180px;
  margin-right: 10px;
  align-self: center;
  @media (max-width: 576px) {
    flex: 1 1 100%;
    margin-bottom: 4px;
  }
`;

const inputStyle = {
  width: "100%",
  alignItems: "center",
  border: "1px solid black",
};

const pickArray = (res) => {
  const d = res && res.data;
  if (!d) return [];
  if (Array.isArray(d)) return d;
  if (Array.isArray(d.result)) return d.result;
  if (Array.isArray(d.data)) return d.data;
  if (Array.isArray(d.rows)) return d.rows;
  if (Array.isArray(d.list)) return d.list;
  return [];
};

const formatDateCell = (v) => {
  if (v == null || v === "") return "";
  const s = String(v);
  if (s.length >= 10 && s.includes("-")) return s.slice(0, 10);
  return s;
};

const toDateInputValue = (v) => {
  if (v == null || v === "") return "";
  const s = String(v);
  if (s.length >= 10 && s.includes("-")) return s.slice(0, 10);
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return "";
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

function SpecialPricing() {
  const history = useHistory();
  const classes = useFormTextFieldStyles();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [pymtOptions, setPymtOptions] = useState([]);
  const [fSearch, setFSearch] = useState("");
  const [filterQuery, setFilterQuery] = useState("");
  const [formErrors, setFormErrors] = useState({});

  const [speccode, setSpeccode] = useState("");
  const [specdesc, setSpecdesc] = useState("");
  const [specprice, setSpecprice] = useState("");
  const [pymtid, setPymtid] = useState("");
  const [criteria, setCriteria] = useState("");
  const [saletracker, setSaletracker] = useState("");
  const [startdate, setStartdate] = useState("");
  const [enddate, setEnddate] = useState("");
  const [activesp, setActivesp] = useState("");

  const resetForm = useCallback(() => {
    setSpeccode("");
    setSpecdesc("");
    setSpecprice("");
    setPymtid("");
    setCriteria("");
    setSaletracker("");
    setStartdate("");
    setEnddate("");
    setActivesp("");
    setFormErrors({});
  }, []);

  useEffect(() => {
    if (!modalOpen) return;
    get_pymtplan_dropdown_api()
      .then((res) => {
        if (res.data && res.data.code === 200) {
          setPymtOptions(pickArray(res));
        } else if (res.data && res.data.message) {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        message.error(err.message || "Failed to load payment plans");
      });
  }, [modalOpen]);

  const loadList = useCallback(() => {
    setLoading(true);
    get_special_pricing_list_api()
      .then((res) => {
        if (res.data && res.data.code === 200) {
          setList(pickArray(res));
        } else if (res.data && res.data.message) {
          message.error(res.data.message);
          setList([]);
        }
      })
      .catch((err) => {
        message.error(err.message || "Failed to load special pricing list");
        setList([]);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (localStorage.getItem("Name") !== "vasanth") {
      history.push("/guvrix_admin");
      return;
    }
    loadList();
  }, [history, loadList]);

  const filteredRows = useMemo(() => {
    if (!filterQuery.trim()) return list;
    const q = filterQuery.trim().toLowerCase();
    return list.filter((row) => {
      const blob = [
        row.speccode,
        row.specdesc,
        row.specprice,
        row.pymtdesc,
        row.pymtid,
        row.criteria,
        row.saletracker,
        row.startdate,
        row.enddate,
        row.activesp,
      ]
        .map((x) => (x == null ? "" : String(x).toLowerCase()))
        .join(" ");
      return blob.includes(q);
    });
  }, [list, filterQuery]);

  const validate = () => {
    const err = {};
    let ok = true;
    if (!String(speccode || "").trim()) {
      ok = false;
      err.speccode_error = "Spec code is required.";
    } else if (String(speccode).trim().length > 20) {
      ok = false;
      err.speccode_error = "Spec code must not exceed 20 characters.";
    }
    if (!String(specdesc || "").trim()) {
      ok = false;
      err.specdesc_error = "Spec description is required.";
    }
    if (specprice === "" || specprice == null) {
      ok = false;
      err.specprice_error = "Spec price is required.";
    } else if (Number.isNaN(Number(specprice))) {
      ok = false;
      err.specprice_error = "Spec price must be a valid number.";
    }
    if (!String(pymtid || "").trim()) {
      ok = false;
      err.pymtid_error = "Payment plan is required.";
    }
    if (!String(activesp || "").trim()) {
      ok = false;
      err.activesp_error = "Active (Y/N) is required.";
    }
    setFormErrors(err);
    return ok;
  };

  const openAdd = () => {
    setEditMode(false);
    resetForm();
    setActivesp("Y");
    setModalOpen(true);
  };

  const openEdit = (row) => {
    setEditMode(true);
    setFormErrors({});
    setSpeccode(row.speccode != null ? String(row.speccode) : "");
    setSpecdesc(row.specdesc != null ? String(row.specdesc) : "");
    setSpecprice(
      row.specprice != null && row.specprice !== "" ? String(row.specprice) : ""
    );
    setPymtid(row.pymtid != null ? String(row.pymtid) : "");
    setCriteria(row.criteria != null ? String(row.criteria) : "");
    setSaletracker(row.saletracker != null ? String(row.saletracker) : "");
    setStartdate(toDateInputValue(row.startdate));
    setEnddate(toDateInputValue(row.enddate));
    setActivesp(row.activesp != null ? String(row.activesp) : "");
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    resetForm();
    setEditMode(false);
  };

  const payload = () => ({
    speccode: String(speccode || "").trim(),
    specdesc: String(specdesc || "").trim(),
    specprice: specprice === "" ? "" : Number(specprice),
    pymtid: pymtid,
    criteria: String(criteria || "").trim(),
    saletracker: String(saletracker || "").trim(),
    startdate: startdate || "",
    enddate: enddate || "",
    activesp: activesp,
  });

  const applySearch = () => {
    setFilterQuery(fSearch.trim());
  };

  const resetFilters = () => {
    setFSearch("");
    setFilterQuery("");
    loadList();
  };

  const submitSave = () => {
    if (!validate()) return;
    const body = payload();
    const api = editMode ? edit_special_pricing_api : add_special_pricing_api;
    setSaving(true);
    api(body)
      .then((res) => {
        if (res.data && res.data.code === 200) {
          message.success(
            editMode
              ? "Special pricing updated successfully"
              : "Special pricing added successfully"
          );
          closeModal();
          loadList();
        } else if (res.data && res.data.message) {
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        message.error(err.message || "Request failed");
      })
      .finally(() => setSaving(false));
  };

  return (
    <div className="container pb-4" style={{ maxWidth: "100%" }}>
      <div className="text-center mt-3 mb-3">
        <h4>Special Pricing</h4>
      </div>

      <div className="d-flex flex-wrap justify-content-center align-items-center gap-2 mb-3 px-2">
        <StyledButton type="button" onClick={() => history.push("/support_menu")}>
          Back to Support Menu
        </StyledButton>
        <StyledButton type="button" onClick={openAdd}>
          Add Special Pricing
        </StyledButton>
      </div>

      <div className=" mt-3">
        <div
          className="EXTQ  FilterS"
          style={{
            width: "100%",
            marginTop: 20,
            padding: 20,
            border: "black solid 1px",
            borderRadius: 50,
          }}
        >
          <div className="EXTQ">
            <div className="row filter-row">
              <div
                style={{ padding: " 0 10px 4px" }}
                className="col-md-4 filter-col"
              >
                <input
                  style={{ width: "100%" }}
                  placeholder="Filter records by any field"
                  value={fSearch}
                  onChange={(e) => setFSearch(e.target.value)}
                  type="text"
                />
              </div>
            </div>
            <div className="col" align="center">
              <StyledButton1
                style={{
                  width: "18%",
                  height: 30,
                  marginTop: 15,
                  marginLeft: 10,
                }}
                type="button"
                onClick={applySearch}
              >
                Search
              </StyledButton1>
              <StyledButton1
                style={{
                  width: "18%",
                  height: 30,
                  marginTop: 15,
                  marginLeft: 10,
                }}
                type="button"
                onClick={resetFilters}
              >
                Reset
              </StyledButton1>
            </div>
          </div>
        </div>

        <Spin spinning={loading}>
          <div className="m-4 table-responsive tableFixHead">
            <StyledDiv>
              <StyledTable>
                <thead>
                  <ScrollTableHeader>
                    <StyledTableHeaderData>S.No</StyledTableHeaderData>
                    <StyledTableHeaderData>Special Code</StyledTableHeaderData>
                    <StyledTableHeaderData>Description</StyledTableHeaderData>
                    <StyledTableHeaderData>Price</StyledTableHeaderData>
                    <StyledTableHeaderData>Payment Plan</StyledTableHeaderData>
                    <StyledTableHeaderData>Criteria</StyledTableHeaderData>
                    <StyledTableHeaderData>Saletracker</StyledTableHeaderData>
                    <StyledTableHeaderData>Start Date</StyledTableHeaderData>
                    <StyledTableHeaderData>End Date</StyledTableHeaderData>
                    <StyledTableHeaderData>Status</StyledTableHeaderData>
                    <StyledTableHeaderData>Action</StyledTableHeaderData>
                  </ScrollTableHeader>
                </thead>
                <tbody>
                  {filteredRows &&
                    filteredRows.map((data, index) => (
                      <StyledTableRow key={`${data.speccode}-${data.pymtid}-${index}`}>
                        <td align="center">{index + 1}</td>
                        <td align="center">{data.speccode}</td>
                        <td align="center">{data.specdesc}</td>
                        <td align="center">{data.specprice}</td>
                        <td align="center">{data.pymtdesc}</td>
                        <td align="center">{data.criteria}</td>
                        <td align="center">{data.saletracker}</td>
                        <td align="center">{formatDateCell(data.startdate)}</td>
                        <td align="center">{formatDateCell(data.enddate)}</td>
                        <td align="center">{data.activesp}</td>
                        <td align="center">
                          <a
                            href="#edit"
                            onClick={(e) => {
                              e.preventDefault();
                              openEdit(data);
                            }}
                          >
                            <i className="fas fa-pencil-alt" aria-hidden="true" />
                          </a>
                        </td>
                      </StyledTableRow>
                    ))}
                </tbody>
              </StyledTable>
            </StyledDiv>
          </div>
        </Spin>
      </div>

      <ReactModal className="ModalStyle4 Width90" isOpen={modalOpen} onRequestClose={closeModal}>
        <Spin spinning={saving}>
          <div style={{ maxHeight: "80vh" }}>
            <StyledForm onSubmit={(e) => e.preventDefault()}>
              <div align="center" className="mb-3">
                <h4>{editMode ? "Edit Special Pricing" : "Add Special Pricing"}</h4>
              </div>

              <StyledFormInputDiv>
                <div style={FormDivStyle}>
                  <StyledLabel htmlFor="speccode">Speical Code</StyledLabel>
                </div>
                <div style={{ flex: "1 1 220px", minWidth: 0 }}>
                  <input
                    id="speccode"
                    type="text"
                    style={{
                      ...inputStyle,
                      backgroundColor: editMode ? "#f0f0f0" : "#fff",
                    }}
                    readOnly={editMode}
                    value={speccode}
                    onChange={(e) => setSpeccode(e.target.value)}
                  />
                </div>
              </StyledFormInputDiv>
              {formErrors.speccode_error && (
                <div className="mt-1">
                  <p style={{ color: "red", fontSize: ".8rem", margin: 0 }}>
                    {formErrors.speccode_error}
                  </p>
                </div>
              )}

              <StyledFormInputDiv>
                <div style={FormDivStyle}>
                  <StyledLabel htmlFor="specdesc">Description</StyledLabel>
                </div>
                <div style={{ flex: "1 1 220px", minWidth: 0 }}>
                  <input
                    id="specdesc"
                    type="text"
                    style={inputStyle}
                    value={specdesc}
                    onChange={(e) => setSpecdesc(e.target.value)}
                  />
                </div>
              </StyledFormInputDiv>
              {formErrors.specdesc_error && (
                <div className="mt-1">
                  <p style={{ color: "red", fontSize: ".8rem", margin: 0 }}>
                    {formErrors.specdesc_error}
                  </p>
                </div>
              )}

              <StyledFormInputDiv>
                <div style={FormDivStyle}>
                  <StyledLabel htmlFor="specprice">Price</StyledLabel>
                </div>
                <div style={{ flex: "1 1 220px", minWidth: 0 }}>
                  <input
                    id="specprice"
                    type="number"
                    style={inputStyle}
                    value={specprice}
                    onChange={(e) => setSpecprice(e.target.value)}
                  />
                </div>
              </StyledFormInputDiv>
              {formErrors.specprice_error && (
                <div className="mt-1">
                  <p style={{ color: "red", fontSize: ".8rem", margin: 0 }}>
                    {formErrors.specprice_error}
                  </p>
                </div>
              )}

              <StyledFormInputDiv>
                <div style={FormDivStyle}>
                  <StyledLabel htmlFor="pymtid">Plan</StyledLabel>
                </div>
                <div style={{ flex: "1 1 220px", minWidth: 0 }}>
                  <select
                    id="pymtid"
                    style={inputStyle}
                    value={pymtid}
                    onChange={(e) => setPymtid(e.target.value)}
                  >
                    <option value="" disabled hidden>
                      Select payment plan
                    </option>
                    {pymtOptions.map((opt, idx) => (
                      <option key={idx} value={String(opt.pymtid)}>
                        {opt.pymtdesc != null ? String(opt.pymtdesc) : String(opt.pymtid)}
                      </option>
                    ))}
                  </select>
                </div>
              </StyledFormInputDiv>
              {formErrors.pymtid_error && (
                <div className="mt-1">
                  <p style={{ color: "red", fontSize: ".8rem", margin: 0 }}>
                    {formErrors.pymtid_error}
                  </p>
                </div>
              )}

              <StyledFormInputDiv>
                <div style={FormDivStyle}>
                  <StyledLabel htmlFor="criteria">Criteria</StyledLabel>
                </div>
                <div style={{ flex: "1 1 220px", minWidth: 0 }}>
                  <input
                    id="criteria"
                    type="text"
                    style={inputStyle}
                    value={criteria}
                    onChange={(e) => setCriteria(e.target.value)}
                  />
                </div>
              </StyledFormInputDiv>

              <StyledFormInputDiv>
                <div style={FormDivStyle}>
                  <StyledLabel htmlFor="saletracker">Saletracker</StyledLabel>
                </div>
                <div style={{ flex: "1 1 220px", minWidth: 0 }}>
                  <input
                    id="saletracker"
                    type="text"
                    style={inputStyle}
                    value={saletracker}
                    onChange={(e) => setSaletracker(e.target.value)}
                  />
                </div>
              </StyledFormInputDiv>

              <StyledFormInputDiv>
                <div style={FormDivStyle}>
                  <StyledLabel htmlFor="startdate">Start Date</StyledLabel>
                </div>
                <div style={{ flex: "1 1 220px", minWidth: 0 }}>
                  <TextField
                    id="startdate"
                    type="date"
                    value={startdate}
                    className={classes.textField}
                    onChange={(e) => setStartdate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                  />
                </div>
              </StyledFormInputDiv>

              <StyledFormInputDiv>
                <div style={FormDivStyle}>
                  <StyledLabel htmlFor="enddate">End Date</StyledLabel>
                </div>
                <div style={{ flex: "1 1 220px", minWidth: 0 }}>
                  <TextField
                    id="enddate"
                    type="date"
                    value={enddate}
                    className={classes.textField}
                    onChange={(e) => setEnddate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                  />
                </div>
              </StyledFormInputDiv>

              <StyledFormInputDiv>
                <div style={FormDivStyle}>
                  <StyledLabel htmlFor="activesp">Status</StyledLabel>
                </div>
                <div style={{ flex: "1 1 220px", minWidth: 0 }}>
                  <select
                    id="activesp"
                    style={inputStyle}
                    value={activesp}
                    onChange={(e) => setActivesp(e.target.value)}
                  >
                    <option value="" disabled hidden>
                      Select Y/N
                    </option>
                    <option value="Y">Y</option>
                    <option value="N">N</option>
                  </select>
                </div>
              </StyledFormInputDiv>
              {formErrors.activesp_error && (
                <div className="mt-1">
                  <p style={{ color: "red", fontSize: ".8rem", margin: 0 }}>
                    {formErrors.activesp_error}
                  </p>
                </div>
              )}

              <div align="center" className="mt-4 mb-2">
                <StyledButtonSmall type="button" onClick={submitSave}>
                  Save
                </StyledButtonSmall>
                <StyledButtonSmall
                  type="button"
                  style={{ backgroundColor: "red" }}
                  onClick={closeModal}
                >
                  Cancel
                </StyledButtonSmall>
              </div>
            </StyledForm>
          </div>
        </Spin>
      </ReactModal>
    </div>
  );
}

export default SpecialPricing;
